import React from 'react';

function Index(props) {
    return (
        <div>
            <p>Income</p>  
        </div>
    );
}

export default Index;